import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import green from '@material-ui/core/colors/green';

const GreenButton = withStyles(theme => ({
    contained: {
        color: '#ffffff',
        backgroundColor: green[500],
        '&:hover': {
            backgroundColor: green[800],
        },
    },
    text: {
        color: green[500],
        '&:hover': {
            backgroundColor: green[100]
        },
    },
    outlined: {
        color: green[500],
        border: '1px solid',
        borderColor: green[500],
        '&:hover': {
            backgroundColor: green[100]
        },
    }
}))(Button);

export default GreenButton;
